import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { deleteZone, updateZone } from "store/actions";
import CreateZone from "./CreateZone";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import TableContainer from '../../components/Common/DataTableContainer';

import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const ZoneTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const permissions = JSON.parse(localStorage?.getItem('permissions'));

  const handleDelete = (zoneId) => {
    dispatch(deleteZone(zoneId));
    setDeleteId("");
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: "Zone Name",
        accessorKey: "zoneName",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true);
          };

          const handleDeleteClick = () => {
            const rowData = row.original;
            setDeleteId(rowData.zoneId); 
            setOpenModal(true);
          };

          return (
            <div className="d-flex gap-2">
              {permissions?.map(item => item?.permissionName)?.includes("Edit Zone") && (
                <Button color="primary" onClick={handleEdit}>
                  <FaRegEdit size={18} />
                </Button>
              )}
              {permissions?.map(item => item?.permissionName)?.includes("Delete Zone") && (
                <Button color="danger" onClick={handleDeleteClick}>
                  <MdDeleteOutline size={18} />
                </Button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const handleSubmit = (data) => {
    dispatch(updateZone(data));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // Meta title
  document.title = "Zone Management | Admin Dashboard";

  return (
    <>
      {/* Confirmation Modal for Deleting Zone */}
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => {
          setDeleteId("");
          setOpenModal(false);
        }}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Zone"
        content="Are you sure you want to delete this zone?"
      />

      {/* Create/Edit Zone Modal */}
      <CreateZone
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="">
        <div className="container-fluid">
          {/* Data Table Container to Display Zones */}
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Zones"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default ZoneTable;
